import React from "react";
import moment from "moment";

import { makeStyles } from "@material-ui/core/styles";

import {
  List,
  TextField,
  FunctionField,
  ReferenceField,
  ReferenceInput,
  SelectInput,
  ReferenceArrayInput,
  AutoCompleteArrayInput,
  Filter,
  FilterButton
} from "jazasoft";

import Datagrid from "../../../components/Datagrid";
// import hasPrivilege from "../../../utils/hasPrivilege";
import { choicesEstimationState } from "../../../constants";

const inputOptions = {
  xs: 12,
  fullWidth: true,
  options: { fullWidth: true }
};

const filters = (
  <Filter>
    <SelectInput label="Status" source="state" choices={choicesEstimationState} {...inputOptions} />
    <ReferenceInput
      label="Product"
      resource="products"
      source="productId"
      reference="products"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}>
      <SelectInput />
    </ReferenceInput>
    <ReferenceInput
      label="Season"
      resource="seasons"
      source="seasonId"
      reference="seasons"
      pageSize={100}
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}>
      <SelectInput />
    </ReferenceInput>
    <ReferenceArrayInput
      label="Customer"
      resource="customers"
      source="customerId"
      reference="customers"
      sort={{ field: "name", order: "asc" }}
      {...inputOptions}>
      <AutoCompleteArrayInput disablePortal={true} />
    </ReferenceArrayInput>
  </Filter>
);

const useStyles = makeStyles(theme => ({
  button: {
    width: theme.spacing(1)
  },
  buttonDelete: {
    width: theme.spacing(1)
  }
}));

const Costing = props => {
  const classes = useStyles();
  return (
    <List
      key={`costing-${props.roles?.join(",")}`}
      searchKeys={["cstId", "styles", "cuChecklist.checklistId"]}
      actions={({ resource }) => (
        <div>
          <FilterButton showLabel={false} resource={resource} />
        </div>
      )}
      filters={filters}
      parse={({ state, productId, customerId, seasonId }) => ({
        state,
        "product.id": productId,
        "customer.id": customerId,
        "season.id": seasonId
      })}
      // filterDefaultValues={props.roles?.includes(Role.CUT_PLANNER) ? { state: EstimationState.PENDING } : {}}
      {...props}>
      <Datagrid rowClick="view" classes={{ headerCell: classes.headerCell, rowCell: classes.rowCell }}>
        <TextField source="cstId" />
        <ReferenceField
          label="Checklist Id"
          source="cuChecklistId"
          reference="cuChecklists"
          allowEmpty
          linkType={record => `/estimation/cuChecklists/${record.cuChecklistId}/view`}>
          <TextField source="checklistId" />
        </ReferenceField>
        <TextField source="product.name" />
        <TextField source="season.name" />
        <TextField source="customer.name" />
        <TextField source="styles" />
        <TextField source="colors" />
        <TextField source="state" />
        <FunctionField label="Created Date" render={record => `${moment(record.createdDate).format("ll")}`} />
      </Datagrid>
    </List>
  );
};

export default Costing;
